import React from "react";

export default function TextArea({ id, value, name, onChange, label = null }) {
  return (
    <div className={"gc__input_container"}>
      {
        label && <label className="gc__input_label" htmlFor={id || undefined}>{label}</label>
      }
      <textarea
        id={id || undefined}
        className={"gc__input_area"}
        name={name}
        value={value}
        rows="4"
        cols="50"
        onChange={onChange}>
      </textarea>
    </div>
  )
}
